import {PureComponent} from 'react'

import Register from './Register.jsx'

import conf from '../../../shared/conf.js'

export default class RegisterAsFreelance extends PureComponent {
  render() {
    const steps = [
      {label: 'Vous vous inscrivez en 2 min', isActive: true},
      {label: 'Nous nous rencontrons en visio'},
      {label: 'Vous recevez des missions'},
    ]

    return <Register
      accountType={conf.accountTypes.freelance}
      metaDescription="Renseignez vos informations en quelques clics : vous pourrez ensuite consulter nos différentes offres de mission et postuler à celles qui vous intéressent"
      metaTitle="Créez votre profil et accédez à nos missions"
      steps={steps}
    />
  }
}
